import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "usbChargingPort"
const UsbChargingPortIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.25 6H9.75V4.5H11.25zM14.25 6H12.75V4.5H14.25z" />
          <path
            fillRule="evenodd"
            d="M17.25 7.5H18.75V12.75C18.75 16.095 16.317 18.87 13.125 19.405V22.5H10.875V19.405C7.683 18.869 5.25 16.095 5.25 12.75V7.5H6.75V1.5H17.25zM6.75 12.75C6.75 15.65 9.1 18 12 18S17.25 15.65 17.25 12.75V9H6.75zM8.25 7.5H15.75V3H8.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UsbChargingPortIcon
